import React from 'react'
import { useParams } from 'react-router-dom'
import SinglePage from '../components/Pages/SinglePage';

function SinglePagePage() {

    const {id} = useParams();

    return (
        <main>
            <div className="container my-4">
                <SinglePage id={id} />
            </div>
        </main>
    )
}
export default SinglePagePage